import React from "react";

import {
    PopupButton,
    PopupButtonsContainer,
    PopupContainer,
    PopupDescription,
    PopupTitle
} from "../../common.styles";

interface FailureProps {
    onConfirm: () => void
    onClose: () => void
}

const Failure = ({ onClose, onConfirm }: FailureProps) => {
    return (
        <PopupContainer>
            <PopupTitle>Something went wrong...</PopupTitle>
            <PopupDescription>Payment processing was declined, please update payment info.</PopupDescription>
            <PopupButtonsContainer>
                <PopupButton
                    variant="outlined"
                    onClick={onConfirm}
                    color="primary"
                    size="large"
                    id="review-button"
                    className="bigButtonInNewStyle"
                >
                    Update now
                </PopupButton>
                <PopupButton
                    variant="contained"
                    onClick={onClose}
                    color="primary"
                    size="large"
                    id="review-button"
                    className="bigButtonInNewStyle"
                >
                    Later
                </PopupButton>
            </PopupButtonsContainer>
        </PopupContainer>
    );
}

export default Failure;
